import React, { useState, useRef, useEffect } from 'react';
import { GridSizeEnum } from '../../helpers/enums';
import { ReactComponent as Check_Grayscale80 } from '../../assets/images/icons/Check_Grayscale80.svg';
import { constants } from '../../helpers/';

import './GridSizePicker.scss';

const GridSizePicker = ({ selectedGridSize, onGridSizeChange }) => {
  const [showGridPicker, setShowGridPicker] = useState(false);
  const [currentGridSize, setCurrentGridSize] = useState(
    selectedGridSize || 'medium',
  );
  const [gridOptionVisible, setGridOptionVisible] = useState(false);
  const gridPickerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      gridPickerRef.current &&
      !gridPickerRef.current.contains(event.target)
    ) {
      setShowGridPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleGridSizeChange = (gridSize) => {
    if (!gridSize || typeof gridSize !== 'string') return;

    setCurrentGridSize(gridSize.toLowerCase());
    setShowGridPicker(false);
    onGridSizeChange(gridSize);
    setGridOptionVisible(false);
  };

  return (
    <div className="grid-size-picker-container" ref={gridPickerRef}>
      <div className="grid-picker-events">
        {/* Tile Large */}
        <div
          className="grid-option"
          onClick={() => handleGridSizeChange(GridSizeEnum.LARGE)}
        >
          <span
            className={currentGridSize === GridSizeEnum.LARGE ? 'selected' : ''}
          >
            {constants.SEARCH_EVENTS_TILE_SIZE_LARGE}
          </span>
          {currentGridSize === GridSizeEnum.LARGE && (
            <Check_Grayscale80 className="check-icon" />
          )}
        </div>
        {/* Tile Medium */}
        <div
          className="grid-option"
          onClick={() => handleGridSizeChange(GridSizeEnum.MEDIUM)}
        >
          <span
            className={
              currentGridSize === GridSizeEnum.MEDIUM ? 'selected' : ''
            }
          >
            {constants.SEARCH_EVENTS_TILE_SIZE_MEDIUM}
          </span>
          {currentGridSize === GridSizeEnum.MEDIUM && (
            <Check_Grayscale80 className="check-icon" />
          )}
        </div>
        {/* Tile Small */}
        <div
          className="grid-option"
          onClick={() => handleGridSizeChange(GridSizeEnum.SMALL)}
        >
          <span
            className={currentGridSize === GridSizeEnum.SMALL ? 'selected' : ''}
          >
            {constants.SEARCH_EVENTS_TILE_SIZE_SMALL}
          </span>
          {currentGridSize === GridSizeEnum.SMALL && (
            <Check_Grayscale80 className="check-icon" />
          )}
        </div>
      </div>
    </div>
  );
};

export default GridSizePicker;
